import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { getSiteKey } from '../../../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getBusinessTypePath } from '../../../utils/api';
export function annotateItem() {
  return _annotateItem.apply(this, arguments);
}
function _annotateItem() {
  _annotateItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _payload;
    var _ref,
      businessId,
      businessType,
      menuItemId,
      _ref2,
      annotationName,
      _ref2$isPositive,
      isPositive,
      recaptchaToken,
      url,
      fullUrl,
      payload,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, businessId = _ref.businessId, businessType = _ref.businessType, menuItemId = _ref.menuItemId;
          _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, annotationName = _ref2.annotationName, _ref2$isPositive = _ref2.isPositive, isPositive = _ref2$isPositive === void 0 ? true : _ref2$isPositive;
          recaptchaToken = _args.length > 2 ? _args[2] : undefined;
          url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
          fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/menu/items/").concat(menuItemId, "/annotate/");
          payload = (_payload = {}, _defineProperty(_payload, annotationName, isPositive), _defineProperty(_payload, 'recaptcha-token', recaptchaToken), _defineProperty(_payload, 'recaptcha-site-key', getSiteKey()), _payload);
          return _context.abrupt("return", axios.patch(fullUrl, payload));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _annotateItem.apply(this, arguments);
}
export function getAnnotationKey(businessId, businessType, id, annotationName) {
  return "catalog-item-".concat(annotationName, "-").concat(businessId, "-").concat(businessType, "-").concat(id);
}
export function updateItemAnnotation(_x, _x2, _x3, _x4, _x5, _x6) {
  return _updateItemAnnotation.apply(this, arguments);
}
function _updateItemAnnotation() {
  _updateItemAnnotation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(businessId, businessType, menuItemId, active, recaptchaToken, annotationName) {
    var payload, identifier;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          payload = {
            annotationName: annotationName,
            isPositive: active
          };
          identifier = {
            businessId: businessId,
            businessType: businessType,
            menuItemId: menuItemId
          };
          _context2.next = 4;
          return annotateItem(identifier, payload, recaptchaToken);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _updateItemAnnotation.apply(this, arguments);
}